module.exports = "#p{\n\n}"